<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <KTCodePreview v-bind:title="'Cadastro de Departamento'">
          <template v-slot:preview>
            <v-form v-model="valid" ref="form">
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-select
                      :items="departamentos"
                      label="Departamento Superior"
                      item-text="nome"
                      item-value="id"
                      v-model="departamento.departamentoSuperiorID"
                    ></v-select>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-select
                      :items="clientes"
                      label="Cliente"
                      item-text="nome"
                      item-value="id"
                      v-model="departamento.clienteID"
                      :rules="[rules.required]"
                      required
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model.trim="departamento.nome"
                      label="Nome"
                      clearable
                      :rules="[rules.required]"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-checkbox
                      v-model="departamento.cadastroEntidades"
                      label="Permitir o cadastro de entidades?"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-btn @click="salvar" color="primary" large :disabled="saving"
                  >Salvar</v-btn
                >
              </v-container>
            </v-form>
          </template>
        </KTCodePreview>
      </div>
    </div>
    <TelaLoading :overlay="saving"></TelaLoading>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import KTCodePreview from "@/views/partials/content/CodePreview.vue";
import ApiService from "@/common/services/http/api.service";
import Swal from "sweetalert2";
import SweetAlert from "@/common/services/sweetalert.service";
import TelaLoading from "@/views/components/TelaLoading.vue";
import Permissoes from "@/common/services/permissoes/permissoes.js";
import Modulo from "@/common/services/permissoes/modulos.js";
import PermissoesService from "@/common/services/permissoes/permissoes.service.js";

export default {
  name: "departamentoCadastro",
  data() {
    return {
      valid: false,
      saving: false,
      departamento: {
        id: 0,
        departamentoSuperiorID: null,
        clienteID: 0,
        nome: "",
        cadastroEntidades: false,
      },
      departamentos: [],
      clientes: [],
      rules: {
        required: (v) => !!v || "Obrigatório",
      },
    };
  },
  components: {
    KTCodePreview,
    TelaLoading,
  },
  methods: {
    listarDepartamentos() {
      return new Promise((resolve) => {
        ApiService.get("departamento").then(({ data }) => {
          if (data.success) {
            resolve(data);
            this.departamentos = data.data;
          } else SweetAlert.sweetAlertError(data.errors);
        });
      });
    },

    listarClientes() {
      return new Promise((resolve) => {
        ApiService.get("cliente").then(({ data }) => {
          if (data.success) {
            resolve(data);
            this.clientes = data.data;
          } else SweetAlert.sweetAlertError(data.errors);
        });
      });
    },
    salvar() {
      let self = this;

      if (this.$refs.form.validate()) {
        this.saving = true;

        if (this.departamento.id === 0) {
          return new Promise((resolve) => {
            ApiService.post("departamento", this.departamento).then(
              ({ data }) => {
                if (data.success) {
                  resolve(data);
                  Swal.fire({
                    position: "center",
                    icon: "success",
                    title: "Departamento Cadastrado com Sucesso!",
                    showConfirmButton: false,
                    timer: 1500,
                  }).then(function () {
                    self.$router.push({ name: "departamento" });
                  });
                } else SweetAlert.sweetAlertError(data.errors);
              }
            );
          }).finally(() => (this.saving = false));
        } else {
          return new Promise((resolve) => {
            ApiService.put(
              "departamento/" + this.departamento.id,
              this.departamento
            ).then(({ data }) => {
              if (data.success) {
                resolve(data);
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Departamento Alterado com Sucesso!",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(function () {
                  self.$router.push({ name: "departamento" });
                });
              } else SweetAlert.sweetAlertError(data.errors);
            });
          }).finally(() => (this.saving = false));
        }
      }
    },

    buscarDepartamento(id) {
      return new Promise((resolve) => {
        ApiService.get("departamento/" + id).then(({ data }) => {
          if (data.success) {
            resolve(data);
            this.departamento = data.data;
          } else SweetAlert.sweetAlertError(data.errors);
        });
      });
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Departamentos" }]);

    this.listarDepartamentos();
    this.listarClientes();

    if (this.$route.params.id !== undefined)
      this.buscarDepartamento(this.$route.params.id);
  },
  created() {
    let permissao = Permissoes.Incluir;

    if (this.$route.params.id !== undefined) permissao = Permissoes.Editar;

    if (!PermissoesService.verificarAcesso(Modulo.Departamento, permissao)) {
      SweetAlert.sweetAlertError([
        "Você não tem permissão para acessar essa parte do sistema",
      ]);
      this.$router.push({ name: "index" });
    }
  },
};
</script>
